import { GoogleCartProperties, GoogleCustomEvent, GoogleStandardEvents, Gtag } from '@xylabs/react-pixel'
import { delay } from '@xylabs/sdk-js'

import { AddressInfoData, ContactInfoData } from '../../models'

export interface GoogleContactInfoComplete extends ContactInfoData, GoogleCartProperties, Record<string, unknown> {}

export interface GoogleAddressInfoComplete extends AddressInfoData, GoogleCartProperties, Record<string, unknown> {}

export interface GoogleViewContent extends Record<string, unknown> {
  name: string
  path: string
}

export interface GoogleUserClick extends Record<string, unknown> {
  elementName: string
  elementType: string
}

export class GoogleEvents<T extends Record<string, unknown>> extends GoogleStandardEvents<T> {
  public async pageView(page_path: string) {
    Gtag.instance.updatePagePath(page_path)
    await delay(0)
  }

  public contactInfoComplete() {
    return new GoogleCustomEvent<GoogleContactInfoComplete | T>('ContactInfoComplete', 'wStWCNWE1-8BEOjZhtgD')
  }

  public addressInfoComplete() {
    return new GoogleCustomEvent<GoogleAddressInfoComplete | T>('AddressInfoComplete', 'b119CLj8lPABEOjZhtgD')
  }

  public paymentInfoComplete() {
    return new GoogleCustomEvent<T>('PaymentInfoComplete', 'EvwsCLGh9e8BEOjZhtgD')
  }

  public transactionAttempted() {
    return new GoogleCustomEvent<T>('TransactionAttempted')
  }

  public transactionFailed() {
    return new GoogleCustomEvent<T>('TransactionFailed')
  }

  public transactionCompleted() {
    return new GoogleCustomEvent<T>('TransactionCompleted', 'Sw3uCICj9e8BEOjZhtgD')
  }

  public upsellViewed() {
    return new GoogleCustomEvent<T>('UpsellViewed')
  }

  public upsellUnavailable() {
    return new GoogleCustomEvent<T>('UpsellUnavailable')
  }

  public upsellAccepted() {
    return new GoogleCustomEvent<T>('UpsellAccepted')
  }

  public upsellSucceeded() {
    return new GoogleCustomEvent<T>('UpsellSucceeded', '8ubgCM6DlfABEOjZhtgD')
  }

  public upsellFailed() {
    return new GoogleCustomEvent<T>('UpsellFailed')
  }

  public trialStarted() {
    return new GoogleCustomEvent<T>('TrialStarted')
  }

  public testStarted() {
    return new GoogleCustomEvent<T>('TestStarted')
  }

  public funnelStarted() {
    return new GoogleCustomEvent<T>('FunnelStarted')
  }

  public viewContent() {
    return new GoogleCustomEvent<GoogleViewContent | T>('ViewContent')
  }

  public userClick() {
    return new GoogleCustomEvent<GoogleUserClick | T>('UserClick')
  }

  public emailCollected() {
    return new GoogleCustomEvent<{ email: string } | T>('EmailCollected')
  }

  public accountCreated() {
    return new GoogleCustomEvent<T>('AccountCreated')
  }

  public shareCompleted() {
    return new GoogleCustomEvent<T>('ShareCompleted')
  }

  public funnelCompleted() {
    return new GoogleCustomEvent<T>('FunnelCompleted')
  }

  public buyticketsCompleted() {
    return new GoogleCustomEvent<T>('BuyTicketsCompleted')
  }

  public installCompleted() {
    return new GoogleCustomEvent<T>('InstallCompleted')
  }

  public offerRequested() {
    return new GoogleCustomEvent<{ id: string } | T>('OfferRequested')
  }

  public feedbackScoreCollected() {
    return new GoogleCustomEvent<{ score: string | number } | T>('FeedbackScoreCollected')
  }

  public feedbackSourceCollected() {
    return new GoogleCustomEvent<{ source: string } | T>('FeedbackSourceCollected')
  }

  public goodFeedbackRequested() {
    return new GoogleCustomEvent<T>('GoodFeedbackRequested')
  }

  public badFeedbackRequested() {
    return new GoogleCustomEvent<T>('BadFeedbackRequested')
  }

  public customEvent(name: string) {
    return new GoogleCustomEvent<T>(name)
  }
}
